import React from "react";
import { Routes, Route } from "react-router-dom";
import TpCourseShell from "../TpPortalMgt/CourseShell/CourseShell";
import TpCreditTypes from "../TpPortalMgt/CreditTypes/CreditTypes";
import TpCreditCapture from "../TpPortalMgt/CreditCapture/CreditCapture";
import TpCreditCaptureStatus from "../TpPortalMgt/CreditCaptureStatus/CreditCaptureStatus";
import TpCtag from "../TpPortalMgt/Ctag/Ctag";
import TpPTPForms from "../TpPortalMgt/PTPForms/PTPForms";
import TpDeliveryDetails from "../TpPortalMgt/DeliveryDetails/DeliveryDetails";
import TpDivisions from "../TpPortalMgt/Divisions/Divisions";
import TpElearnShellTerm from "../TpPortalMgt/ElearnShellTerm/ElearnShellTerm";
import TpElearnShellType from "../TpPortalMgt/ElearnShellType/ElearnShellType";
import TpFps from "../TpPortalMgt/Fps/Fps";
import TpFpsCourses from "../TpPortalMgt/FpsCourses/FpsCourses";
import TpHeiPrograms from "../TpPortalMgt/HeiPrograms/HeiPrograms";
import TpPathwayPrograms from "../TpPortalMgt/PathwayPrograms/PathwayPrograms";
import TpShellStatus from "../TpPortalMgt/ShellStatus/ShellStatus";
import TpCourseShellStatus from "../TpPortalMgt/CourseShellStatus/CourseShellStatus";
import TpSites from "../TpPortalMgt/Sites/Sites";
import TpPartners from "../TpPortalMgt/Partners/Partners";
import TpSsnStatusCode from "../TpPortalMgt/SsnStatusCode/SsnStatusCode";
import TpStudents from "../TpPortalMgt/Students/Students";
import TpStudentArchive from "../TpPortalMgt/Students/StudentArchive";
import TpPortalMgtCourseCatalog from "../TpPortalMgt/CourseCatalog/CourseCatalog";
import TpResidenceStatusCodes from "../TpPortalMgt/ResidenceStatusCodes/ResidenceStatusCodes";
import ProgramDelivery from "../TpPortalMgt/ProgramDelivery/ProgramDelivery";
import ProtectedRoute from "../../config/ProtectedRoute";
import TpUsers from "../TpUsers/TpUsers";
import TpAdmins from "../TpUsers/TpAdmins";
import TpCoordinators from "../TpUsers/TpCoordinators";
import TpInstructors from "../TpUsers/TpInstructors";
import TpStaff from "../TpUsers/TpStaff";
import SearchStudents from "../TpSearchForms/SearchStudents";
import SearchFormerStudents from "../TpSearchForms/SearchFormerStudents";
import SearchCoordinators from "../TpSearchForms/SearchCoordinators";
import SearchInstructors from "../TpSearchForms/SearchInstructors";
import SearchFps from "../TpSearchForms/SearchFps";
import SearchCourses from "../TpSearchForms/SearchCourses";
import Unauthorized from "./Unauthorized";
import StaffProtectedRoute from "../../config/StaffProtectedRoute";
import ShowcaseCategories from "../TpPortalMgt/ShowcaseCategories/ShowcaseCategories";
import ShowcaseLocations from "../TpPortalMgt/ShowcaseLocations/ShowcaseLocations";
import ShowcaseParticipationStatus from "../TpPortalMgt/ShowcaseParticipationStatus/ShowcaseParticipationStatus";
import TpShowcaseSubmissions from "../TpPortalMgt/ShowcaseSubmissions/ShowcaseSubmissions";
import ShowcaseEmailTemplate from "../TpPortalMgt/ShowcaseEmailTemplate/ShowcaseEmailTemplate";
import PTPStatusNote from "../TpPortalMgt/PTPStatusNote/PTPStatusNote";
import TpShowcaseToggles from "../TpShowcaseToggles/TpShowcaseToggles";
import TpData from "../TpPortalMgt/Data/Data";

const TechPrepAdminRoutes = () => {
  return (
    <Routes>
      <Route
        path="/TpResidenceStatusCodes"
        element={
          <ProtectedRoute areaKey="TpResidenceStatusCodes">
            <TpResidenceStatusCodes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpPortalMgtCourseCatalog"
        element={
          <ProtectedRoute areaKey="TpPortalMgtCourseCatalog">
            <TpPortalMgtCourseCatalog />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpPortalMgtCourseShell"
        element={
          <ProtectedRoute areaKey="TpPortalMgtCourseShell">
            <TpCourseShell />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpCreditTypes"
        element={
          <ProtectedRoute areaKey="TpCreditTypes">
            <TpCreditTypes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpCreditCapture"
        element={
          <ProtectedRoute areaKey="TpCreditCapture">
            <TpCreditCapture />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpCreditCaptureStatus"
        element={
          <ProtectedRoute areaKey="TpCreditCaptureStatus">
            <TpCreditCaptureStatus />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpCtag"
        element={
          <ProtectedRoute areaKey="TpCtag">
            <TpCtag />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpPTPForms"
        element={
          <ProtectedRoute areaKey="TpPTPForms">
            <TpPTPForms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpDeliveryDetails"
        element={
          <ProtectedRoute areaKey="TpDeliveryDetails">
            <TpDeliveryDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpDivisions"
        element={
          <ProtectedRoute areaKey="TpDivisions">
            <TpDivisions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpElearnShellTerm"
        element={
          <ProtectedRoute areaKey="TpElearnShellTerm">
            <TpElearnShellTerm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpElearnShellType"
        element={
          <ProtectedRoute areaKey="TpElearnShellType">
            <TpElearnShellType />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpFps"
        element={
          <ProtectedRoute areaKey="TpFps">
            <TpFps />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpFpsCourses"
        element={
          <ProtectedRoute areaKey="TpFpsCourses">
            <TpFpsCourses />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpHeiPrograms"
        element={
          <ProtectedRoute areaKey="TpHeiPrograms">
            <TpHeiPrograms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpPathwayPrograms"
        element={
          <ProtectedRoute areaKey="TpPathwayPrograms">
            <TpPathwayPrograms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpShellStatus"
        element={
          <ProtectedRoute areaKey="TpShellStatus">
            <TpShellStatus />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpCourseShellStatus"
        element={
          <ProtectedRoute areaKey="TpCourseShellStatus">
            <TpCourseShellStatus />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpSites"
        element={
          <ProtectedRoute areaKey="TpSites">
            <TpSites />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpPartners"
        element={
          <ProtectedRoute areaKey="TpPartners">
            <TpPartners />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpSsnStatusCode"
        element={
          <ProtectedRoute areaKey="TpSsnStatusCode">
            <TpSsnStatusCode />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpStudents"
        element={
          <ProtectedRoute areaKey="TpStudents">
            <TpStudents />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpStudentArchive"
        element={
          <ProtectedRoute areaKey="TpStudents">
            <TpStudentArchive />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpUsers"
        element={
          <ProtectedRoute areaKey="TpUsers">
            <TpUsers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpAdmins"
        element={
          <ProtectedRoute areaKey="TpUsers">
            <TpAdmins />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpCoordinators"
        element={
          <ProtectedRoute areaKey="TpUsers">
            <TpCoordinators />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpInstructors"
        element={
          <ProtectedRoute areaKey="TpUsers">
            <TpInstructors />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpStaff"
        element={
          <ProtectedRoute areaKey="TpUsers">
            <TpStaff />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ProgramDelivery"
        element={
          <ProtectedRoute areaKey="ProgramDelivery">
            <ProgramDelivery />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpSearchStudents"
        element={
          <StaffProtectedRoute>
            <SearchStudents />
          </StaffProtectedRoute>
        }
      />
      <Route
        path="/TpSearchFormerStudents"
        element={
          <StaffProtectedRoute>
            <SearchFormerStudents />
          </StaffProtectedRoute>
        }
      />
      <Route
        path="/TpSearchCoordinators"
        element={
          <StaffProtectedRoute>
            <SearchCoordinators />
          </StaffProtectedRoute>
        }
      />
      <Route
        path="/TpSearchInstructors"
        element={
          <StaffProtectedRoute>
            <SearchInstructors />
          </StaffProtectedRoute>
        }
      />
      <Route
        path="/TpSearchFps"
        element={
          <StaffProtectedRoute>
            <SearchFps />
          </StaffProtectedRoute>
        }
      />
      <Route
        path="/TpSearchCourses"
        element={
          <StaffProtectedRoute>
            <SearchCourses />
          </StaffProtectedRoute>
        }
      />
      <Route
        path="/TpShowcaseCategories"
        element={
          <ProtectedRoute areaKey="TpShowcaseCategories">
            <ShowcaseCategories />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpShowcaseLocations"
        element={
          <ProtectedRoute areaKey="TpShowcaseLocations">
            <ShowcaseLocations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpShowcaseParticipationStatus"
        element={
          <ProtectedRoute areaKey="TpShowcaseParticipationStatus">
            <ShowcaseParticipationStatus />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpShowcaseSubmissions"
        element={
          <ProtectedRoute areaKey="TpShowcaseSubmissions">
            <TpShowcaseSubmissions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpShowcaseToggles"
        element={
          <ProtectedRoute areaKey="TpShowcaseToggles">
            <TpShowcaseToggles />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpShowEmailTemplate"
        element={
          <ProtectedRoute areaKey="TpShowEmailTemplate">
            <ShowcaseEmailTemplate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/PTPStatusNote"
        element={
          <ProtectedRoute areaKey="PTPStatusNote">
            <PTPStatusNote />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpData"
        element={
          <ProtectedRoute areaKey="TpData">
            <TpData />
          </ProtectedRoute>
        }
      />
      <Route path="/unauthorized" element={<Unauthorized />} />
    </Routes>
  );
};

export default TechPrepAdminRoutes;
